var NoteView = require('./note'),
    $ = require('jquery'),
    _ = require('underscore');

module.exports = NoteView.extend({

    uiModelEvents: _.extend( {}, NoteView.prototype.uiModelEvents, {

        'change:viewerPgNumber'     : 'updatePgNumber', // ( from set note views navigability -- only applicable to page text notes)
        'change:navigationEnabled'  : 'togglePgNavigationAbility'

    }),


    ui: _.extend( NoteView.prototype.ui, {
        pgNumLink: '.pgNum'
    }),

    onRender: function() {

        NoteView.prototype.onRender.call(this);

        var vc = this.channel.request('vChannel');

        this.uiModel.setNavigationEnabled(
            !vc.request('getViewer') || vc.request('viewMode') === 'pdf'
                ? false
                : !vc.request('pgNoteIsOfActivePage', this.model)
        );

    },

    updatePgNumber: function(uiModel, pgNumber) {

        this.ui.pgNumLink.text( 'p.' + pgNumber );

    },

    togglePgNavigationAbility: function(uiModel, enable) {

        var goToNotePage = function() {
            this.channel.trigger('notes:goToPage', this.model);
        };

        enable
            ? this.ui.pgNumLink.removeClass('disabled').on('click', _.bind(goToNotePage, this))
            : this.ui.pgNumLink.addClass('disabled').off();  //taking off all handlers fixed the problem of the handler not disabling

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/pageNote.js
 ** module id = 178
 ** module chunks = 0
 **/